import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";

const Signup = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    village: "",
    district: "",
    shgName: "",
    membershipType: "",
    hasLivestock: false,
    livestockCount: "",
    feedback: "",
    enquiry: "",
  });
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


  const handleSubmit = (e) => {
  e.preventDefault();

  // Make sure user entered email before sending
  if (!formData.email) {
    alert("Please enter a valid email address to receive confirmation.");
    return;
  }

  const templateParams = {
    name: formData.name,
    phone: formData.phone,
    email: formData.email,
    address: formData.address,
    village: formData.village,
    district: formData.district,
    shgName: formData.shgName || "N/A",
    membershipType: formData.membershipType,
    hasLivestock: formData.hasLivestock ? "Yes" : "No",
    livestockCount: formData.livestockCount || "0",
    feedback: formData.feedback || "N/A",
    enquiry: formData.enquiry || "N/A",
  };

  // Disable submit button until email send completes
  const submitButton = document.querySelector('button[type="submit"]');
  submitButton.disabled = true;
  submitButton.innerText = "Sending...";

  emailjs
    .send(
      "service_pspkrjb",
      "template_6e7kwuc",
      templateParams,
      "wM8JlhV4lPqIYaZpG"
    )
    .then(
      (response) => {
        console.log("EMAIL SENT SUCCESS!", response.status, response.text);
        setShowAlert(true);

        // Reset form
        setFormData({
          name: "",
          phone: "",
          email: "",
          address: "",
          village: "",
          district: "",
          shgName: "",
          membershipType: "",
          hasLivestock: false,
          livestockCount: "",
          feedback: "",
          enquiry: "",
        });

        setTimeout(() => setShowAlert(false), 6000);

        // Re-enable submit button
        submitButton.disabled = false;
        submitButton.innerText = "Submit Registration";
      },
      (error) => {
        console.error("EMAIL SEND FAILED...", error);
        alert(
          "Failed to send confirmation email. Please check your email address or try again later."
        );

        // Re-enable submit button
        submitButton.disabled = false;
        submitButton.innerText = "Submit Registration";
      }
    );
};


  const membershipTypes = [
    { value: "individual", label: "Individual Dairy Farmer" },
    { value: "shg-member", label: "SHG Member" },
    { value: "shg-leader", label: "SHG Leader/Coordinator" },
    { value: "entrepreneur", label: "Dairy Entrepreneur" },
    { value: "partner", label: "Partner Organization" },
  ];

  const signupBenefits = [
    {
      icon: "🎓",
      title: "Free Training",
      desc: "Access to comprehensive dairy management training programs",
    },
    {
      icon: "💰",
      title: "Fair Pricing",
      desc: "Get fair prices for your milk with IoT-based quality testing",
    },
    {
      icon: "🔬",
      title: "Quality Testing",
      desc: "Advanced milk quality analysis using latest technology",
    },
    {
      icon: "🤝",
      title: "Buy-back Guarantee",
      desc: "Assured purchase of all quality milk production",
    },
    {
      icon: "👥",
      title: "Community Support",
      desc: "Join a network of empowered women entrepreneurs",
    },
    {
      icon: "📱",
      title: "Digital Tools",
      desc: "Access to mobile app and digital record keeping",
    },
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section
        className="py-5 mt-5 text-white"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container style={{marginTop:"50px"}}>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Join WiSE</h1>
              <p className="fs-5">
                Become part of the women empowerment movement in dairy
                entrepreneurship
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Signup Form */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mb-5">
              <Card className="border-0 shadow-lg contact-form">
                <Card.Body className="p-5">
                  <h2 className="fw-bold mb-4">Registration Form</h2>
                  <p className="text-muted mb-4">
                    Fill in your details to join WiSE and start your journey
                    towards dairy entrepreneurship
                  </p>

                  {showAlert && (
                    <Alert variant="success" className="mb-4">
                      <strong>Registration Successful!</strong> Welcome to WiSE!
                      Our team will contact you within 24-48 hours to complete
                      your onboarding process.
                    </Alert>
                  )}

                  <Form onSubmit={handleSubmit}>
                    {/* Personal Information */}
                    <h5 className="fw-bold text-primary mb-3">
                      Personal Information
                    </h5>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Full Name *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="border-0 bg-light p-3"
                            placeholder="Enter your full name"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Mobile Number *
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            maxLength="10"
                            className="border-0 bg-light p-3"
                            placeholder="Enter 10-digit mobile number"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Email Address (Optional)
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="border-0 bg-light p-3"
                        placeholder="Enter your email address"
                      />
                    </Form.Group>

                    {/* Address Information */}
                    <h5 className="fw-bold text-primary mb-3 mt-4">
                      Address Information
                    </h5>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Complete Address *
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                        className="border-0 bg-light p-3"
                        placeholder="Enter your complete address"
                      />
                    </Form.Group>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Village/Town *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="village"
                            value={formData.village}
                            onChange={handleChange}
                            required
                            className="border-0 bg-light p-3"
                            placeholder="Enter village/town name"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            District *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="district"
                            value={formData.district}
                            onChange={handleChange}
                            required
                            className="border-0 bg-light p-3"
                            placeholder="Enter district name"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Membership Information */}
                    <h5 className="fw-bold text-primary mb-3 mt-4">
                      Membership Information
                    </h5>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Membership Type *
                          </Form.Label>
                          <Form.Select
                            name="membershipType"
                            value={formData.membershipType}
                            onChange={handleChange}
                            required
                            className="border-0 bg-light p-3"
                          >
                            <option value="">Select membership type</option>
                            {membershipTypes.map((type, index) => (
                              <option key={index} value={type.value}>
                                {type.label}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            SHG Name (if applicable)
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="shgName"
                            value={formData.shgName}
                            onChange={handleChange}
                            className="border-0 bg-light p-3"
                            placeholder="Enter your SHG name"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Livestock Information */}
                    <h5 className="fw-bold text-primary mb-3 mt-4">
                      Livestock Information
                    </h5>
                    <Form.Group className="mb-3">
                      <Form.Check
                        type="checkbox"
                        name="hasLivestock"
                        checked={formData.hasLivestock}
                        onChange={handleChange}
                        label="I own dairy animals (cows/buffaloes)"
                        className="fw-semibold"
                      />
                    </Form.Group>

                    {formData.hasLivestock && (
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Number of Dairy Animals
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="livestockCount"
                          value={formData.livestockCount}
                          onChange={handleChange}
                          min="1"
                          className="border-0 bg-light p-3"
                          placeholder="Enter number of cows/buffaloes"
                        />
                      </Form.Group>
                    )}

                    {/* Additional Information */}
                    <h5 className="fw-bold text-primary mb-3 mt-4">
                      Additional Information
                    </h5>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Feedback/Suggestions
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="feedback"
                        value={formData.feedback}
                        onChange={handleChange}
                        className="border-0 bg-light p-3"
                        placeholder="Share your feedback or suggestions about dairy entrepreneurship"
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">
                        Enquiry/Questions
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="enquiry"
                        value={formData.enquiry}
                        onChange={handleChange}
                        className="border-0 bg-light p-3"
                        placeholder="Any specific questions or enquiries about WiSE programs?"
                      />
                    </Form.Group>

                    <Button
                      type="submit"
                      className="btn-primary-custom btn-lg w-100"
                    >
                      Submit Registration
                    </Button>
                  </Form>

                  {/* <div className="text-center mt-4">
                    <p className="text-muted">
                      Already have an account?
                      <Link
                        to="/login"
                        className="text-primary fw-semibold ms-2"
                      >
                        Login Here
                      </Link>
                    </p>
                  </div> */}
                </Card.Body>
              </Card>
            </Col>

            {/* Benefits Sidebar */}
            <Col lg={4}>
              <div className="sticky-top" style={{ top: "100px" }}>
                <h3 className="fw-bold mb-4">Why Join WiSE?</h3>
                {signupBenefits.map((benefit, index) => (
                  <Card
                    key={index}
                    className="border-0 shadow-sm mb-3 hover-lift"
                  >
                    <Card.Body className="p-3">
                      <div className="d-flex align-items-center">
                        <div className="me-3" style={{ fontSize: "1.5rem" }}>
                          {benefit.icon}
                        </div>
                        <div>
                          <h6 className="fw-bold mb-1">{benefit.title}</h6>
                          <small className="text-muted">{benefit.desc}</small>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Next Steps */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="fw-bold mb-4">What Happens Next?</h2>
              <Row>
                <Col md={4} className="mb-4">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div style={{ fontSize: "2rem" }}>📞</div>
                    <h5 className="fw-bold mt-2">1. Contact</h5>
                    <p className="small text-muted">
                      Our team will call you within 24-48 hours
                    </p>
                  </div>
                </Col>
                <Col md={4} className="mb-4">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div style={{ fontSize: "2rem" }}>✅</div>
                    <h5 className="fw-bold mt-2">2. Verification</h5>
                    <p className="small text-muted">
                      Quick verification of your details and requirements
                    </p>
                  </div>
                </Col>
                <Col md={4} className="mb-4">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div style={{ fontSize: "2rem" }}>🎯</div>
                    <h5 className="fw-bold mt-2">3. Onboarding</h5>
                    <p className="small text-muted">
                      Complete onboarding and start your WiSE journey
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Signup;
